import { initializeApp } from "firebase/app";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { getFirestore, doc, setDoc, collection, query, where, getDocs, limit, updateDoc, getDoc as getFirestoreDoc, arrayUnion } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyDwgokJ342kxknQlFeOmlLwSI14WsdiDnI",
    authDomain: "portal-sisfol.firebaseapp.com",
    projectId: "portal-sisfol",
    storageBucket: "portal-sisfol.firebasestorage.app",
    messagingSenderId: "693463369463",
    appId: "1:693463369463:web:cc5025a2018494336af5f2",
    measurementId: "G-Z42ZWVLREM"
};

const firestorePathId = 'sisfol-rh-online';

const app = initializeApp(firebaseConfig);

export const storage = getStorage(app);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const messaging = getMessaging(app);
export { firestorePathId };

/**
 * Solicita permissão para notificações e salva o token FCM no documento do servidor.
 */
export const requestNotificationPermissionAndSaveToken = async (municipioId, servidorDocId) => {
    try {
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
            const registration = await navigator.serviceWorker.ready;
            
            const currentToken = await getToken(messaging, {
                vapidKey: 'BHKCnHRrlw2Ojo_F113jJqcgeC0H6J5WE33xG6c_VLJctl3plvNskkKJIYRxwOO7ccJ11oUMsXx9VwlA9OooXrE',
                serviceWorkerRegistration: registration,
            });

            if (currentToken) {
                const servidorDocRef = doc(db, `artifacts/${firestorePathId}/public/data/municipalities/${municipioId}/DadosServidores`, servidorDocId);

                await updateDoc(servidorDocRef, {
                    fcmTokens: arrayUnion(currentToken)
                });
            } else {
                console.log('Não foi possível obter o token de notificação.');
            }
        } else {
            console.log('Permissão para notificação negada.');
        }
    } catch (error) {
        console.error('Ocorreu um erro ao obter o token de notificação:', error);
    }
};

/**
 * Função para alterar a senha do servidor no Firestore.
 */
export const updateServerPassword = async (municipioId, cpf, newPassword) => {
    try {
        const cleanedCpf = cpf.replace(/[.-]/g, '');
        const credentialPath = `artifacts/${firestorePathId}/public/data/municipalities/${municipioId}/Servidoresacesso/${cleanedCpf}`;
        const credentialDocRef = doc(db, credentialPath);
        
        // CORREÇÃO: O campo no banco de dados é 'primeiroAcesso'. 
        // A atualização agora usa o nome de campo correto para corresponder às regras de segurança.
        await updateDoc(credentialDocRef, {
            senha: newPassword,
            primeiroAcesso: false,
            updatedAt: new Date()
        });
    } catch (error) {
        console.error("Erro ao atualizar a senha do servidor:", error);
        throw error;
    }
};

/**
 * Função para fazer upload de um arquivo para o Firebase Storage.
 */
export const uploadFile = async (file, path) => {
    try {
        if (!file || !path) {
            throw new Error("Arquivo ou caminho de upload não fornecidos.");
        }
        const storageRef = ref(storage, path);
        const snapshot = await uploadBytes(storageRef, file);
        const downloadURL = await getDownloadURL(snapshot.ref);
        return downloadURL;
    } catch (error) {
        console.error("Erro detalhado ao fazer upload do arquivo:", error);
        throw error;
    }
};

/**
 * Salva ou atualiza os dados de recadastramento em um caminho estruturado com o nome da campanha.
 */
export const saveRecadastramento = async (municipioId, campaignName, data) => {
    try {
        if (!municipioId || !campaignName || !data.userCpf || !data.vinculoId) {
            throw new Error("Dados insuficientes para salvar: municipioId, campaignName, userCpf e vinculoId são obrigatórios.");
        }
        
        const docId = `${data.userCpf}-${data.vinculoId}`;
        const docPath = `artifacts/${firestorePathId}/public/data/municipalities/${municipioId}/recadastramentos/${docId}`;
        const docRef = doc(db, docPath);

        await setDoc(docRef, data, { merge: true });
        
        return docId;
    } catch (error) {
        console.error("Erro ao salvar dados no Firestore:", error);
        throw error;
    }
};


/**
 * Busca os dados de recadastramento de um servidor pelo ID do documento (protocolo).
 */
export const getRecadastramentoById = async (municipioId, campaignName, docId) => {
    try {
        if (!docId || !municipioId || !campaignName) {
            console.warn("getRecadastramentoById: docId, municipioId ou campaignName não fornecidos.");
            return null;
        }

        const docPath = `artifacts/${firestorePathId}/public/data/municipalities/${municipioId}/recadastramentos/${docId}`;
        const docRef = doc(db, docPath);
        const docSnap = await getFirestoreDoc(docRef, { source: 'server' });

        if (docSnap.exists()) {
            return docSnap.data();
        } else {
            return null;
        }
    } catch (error) {
        console.error("Erro ao buscar recadastramento por ID:", error);
        throw error;
    }
};

/**
 * Busca os dados de recadastramento de um servidor pelo seu userId.
 */
export const getRecadastramentoByUserId = async (municipioId, campaignName, userId) => {
    try {
        if (!userId || !municipioId || !campaignName) {
            return null;
        }

        const collectionPath = `artifacts/${firestorePathId}/public/data/municipalities/${municipioId}/recadastramentos`;
        const collectionRef = collection(db, collectionPath);
        const q = query(collectionRef, where("userId", "==", userId), limit(1));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
            const docSnap = querySnapshot.docs[0];
            return { id: docSnap.id, ...docSnap.data() };
        } else {
            return null;
        }
    } catch (error) {
        console.error("Erro ao buscar recadastramento por userId:", error);
        throw error;
    }
};

/**
 * Busca os dados de recadastramento de um servidor pelo seu CPF.
 */
export const getRecadastramentoByCPF = async (municipioId, campaignName, cpf) => {
    try {
        if (!cpf || !municipioId || !campaignName) {
            console.warn("getRecadastramentoByCPF: cpf, municipioId ou campaignName inválido/ausente.");
            return null;
        }

        const collectionPath = `artifacts/${firestorePathId}/public/data/municipalities/${municipioId}/recadastramentos`;
        const collectionRef = collection(db, collectionPath);
        const q = query(collectionRef, where("dadosPessoais.cpf.value", "==", cpf), limit(1));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
            const docSnap = querySnapshot.docs[0];
            return { id: docSnap.id, ...docSnap.data() };
        } else {
            console.log("Nenhum recadastramento encontrado para o CPF:", cpf, "na campanha:", campaignName);
            return null;
        }
    } catch (error) {
        console.error("Erro ao buscar recadastramento por CPF:", error);
        throw error;
    }
};

/**
 * Busca as regras de campos obrigatórios da campanha ativa.
 */
export const getActiveCampaignRequiredFields = async (municipioId) => {
    try {
        const campaignsCollectionRef = collection(db, `artifacts/${firestorePathId}/public/data/recadastramentoCampaigns`);
        const q = query(
            campaignsCollectionRef,
            where('status', '==', 'ativa'),
            where('municipioId', '==', municipioId),
            limit(1)
        );
        
        const querySnapshot = await getDocs(q);
        
        if (!querySnapshot.empty) {
            return { id: querySnapshot.docs[0].id, ...querySnapshot.docs[0].data() };
        } else {
            console.warn("AVISO: Nenhuma campanha ativa encontrada.");
            return null;
        }
    } catch (error) {
        console.error("ERRO CRÍTICO ao buscar campanha ativa:", error);
        console.error("VERIFIQUE ACIMA: Se a mensagem de erro mencionar 'index' ou 'índice', você PRECISA de clicar no link que o Firebase fornece para criar o índice na base de dados.");
        throw error;
    }
};

/**
 * Atualiza o status de um recadastramento pelo ID do documento (protocolo).
 */
export const updateRecadastramentoStatus = async (municipioId, campaignName, docId, newStatus) => {
    try {
        if (!docId || !municipioId || !newStatus || !campaignName) {
            throw new Error("docId, municipioId, campaignName e newStatus devem ser fornecidos.");
        }

        const docPath = `artifacts/${firestorePathId}/public/data/municipalities/${municipioId}/recadastramentos/${docId}`;
        const docRef = doc(db, docPath);
        await updateDoc(docRef, {
            status: newStatus,
            lastUpdate: new Date(),
        });
    } catch (error) {
        console.error("Erro ao atualizar o status do recadastramento:", error);
        throw error;
    }
};


/**
 * Busca os dados de um município específico pelo seu ID.
 */
export const getMunicipioById = async (municipioId) => {
    try {
        if (!municipioId) {
            console.warn("getMunicipioById: municipioId não fornecido.");
            return null;
        }
        const docRef = doc(db, `artifacts/${firestorePathId}/public/data/municipalities`, municipioId);
        const docSnap = await getFirestoreDoc(docRef);

        if (docSnap.exists()) {
            return docSnap.data();
        } else {
            console.warn("Nenhum documento de município encontrado para o ID:", municipioId);
            return null;
        }
    } catch (error) {
        console.error("Erro ao buscar dados do município:", error);
        throw error;
    }
};

/**
 * Busca os dados de um usuário RH específico pelo seu ID.
 */
export const getRhUserById = async (rhUserId) => {
    try {
        if (!rhUserId) {
            console.warn("getRhUserById: rhUserId não fornecido.");
            return null;
        }
        const docRef = doc(db, `artifacts/${firestorePathId}/public/data/rhUsers`, rhUserId);
        const docSnap = await getFirestoreDoc(docRef);

        if (docSnap.exists()) {
            return docSnap.data();
        } else {
            console.warn("Nenhum usuário RH encontrado para o ID:", rhUserId);
            return null;
        }
    } catch (error) {
        console.error("Erro ao buscar dados do usuário RH:", error);
        throw error;
    }
};

/**
 * Busca os dados de um servidor na coleção DadosServidores pelo seu CPF.
 */
export const getDadosServidorByCPF = async (municipioId, cpf) => {
    try {
        if (!municipioId || !cpf) {
            console.warn("getDadosServidorByCPF: municipioId ou cpf não fornecidos.");
            return null;
        }
        const cleanedCpf = cpf.replace(/[.-]/g, '');
        const docRef = doc(db, `artifacts/${firestorePathId}/public/data/municipalities/${municipioId}/DadosServidores`, cleanedCpf);
        const docSnap = await getFirestoreDoc(docRef);

        if (docSnap.exists()) {
            return docSnap.data();
        } else {
            console.warn("Nenhum dado de servidor encontrado para o CPF:", cleanedCpf, "no município:", municipioId);
            return null;
        }
    } catch (error) {
        console.error("Erro ao buscar dados do servidor por CPF:", error);
        throw error;
    }
};

